import type { FC } from "react";

import Image from "next/image";

import { QrCodePointsCollection as UIQrCodePointsCollection } from "@jti/loyalty/components/QrCodePointsCollection";

import type { qrCodePointsCollectionInputs } from "./QrCodePointsCollection.builder";

type QrCodePointsCollectionBuilderProps = BuilderComponentProps<typeof qrCodePointsCollectionInputs>;

export const QrCodePointsCollection: FC<QrCodePointsCollectionBuilderProps> = ({ logoHeight, logoWidth, ...props }) => {
  return (
    <UIQrCodePointsCollection
      {...props}
      clipped={false}
      mobileVariant="transparentContentOnTop"
      displayScrollBar={false}
      renderImage={({ src, alt }: { src: string; alt: string }) => (
        <Image src={src} alt={alt} height={logoHeight || 63} width={logoWidth || 100} />
      )}
    />
  );
};
